/**
 * Header Help button.
 *
 * Opens the help overlay in place — no navigation, so the page underneath keeps its
 * state and the app does not remount. When the current page declares an article (via
 * `usePageHelp`) the overlay opens on that article; otherwise it opens on the task
 * catalogue.
 */

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { useActiveHelpId, useHelpOverlay } from '../../../help/HelpContext';
import { useContextualArticleId } from '../../../help/useContextualArticle';

const HelpButton = () => {
    const { open } = useHelpOverlay();
    const helpId = useContextualArticleId(useActiveHelpId());

    return (
        <Tooltip title={helpId ? 'Help for this page' : 'Help'}>
            <IconButton color="inherit" size="medium" onClick={open} aria-label="Open help">
                <HelpOutlineIcon />
            </IconButton>
        </Tooltip>
    );
};

export default HelpButton;
